/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  SubscriptionUserControllerFindPlansQueryResponse,
  SubscriptionUserControllerFindPlans401,
} from '../../types/SubscriptionUserControllerFindPlans.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { subscriptionUserFindPlans } from '../../methods/subscriptionUserFindPlans.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const subscriptionUserFindPlansQueryKey = () => [{ url: '/api/user/telegram/subscriptions/plans' }] as const;

export type SubscriptionUserFindPlansQueryKey = ReturnType<typeof subscriptionUserFindPlansQueryKey>;

export function subscriptionUserFindPlansQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = subscriptionUserFindPlansQueryKey();
  return queryOptions<
    SubscriptionUserControllerFindPlansQueryResponse,
    ResponseErrorConfig<SubscriptionUserControllerFindPlans401>,
    SubscriptionUserControllerFindPlansQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return subscriptionUserFindPlans(config);
    },
  });
}

/**
 * {@link /api/user/telegram/subscriptions/plans}
 */
export function useSubscriptionUserFindPlans<
  TData = SubscriptionUserControllerFindPlansQueryResponse,
  TQueryData = SubscriptionUserControllerFindPlansQueryResponse,
  TQueryKey extends QueryKey = SubscriptionUserFindPlansQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        SubscriptionUserControllerFindPlansQueryResponse,
        ResponseErrorConfig<SubscriptionUserControllerFindPlans401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? subscriptionUserFindPlansQueryKey();

  const query = useQuery(
    {
      ...subscriptionUserFindPlansQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<SubscriptionUserControllerFindPlans401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
